/** 极速番摊 — 靜態演示結構（接口接入後替換） */

export const FANTAN_LOTTERY_NAME = '极速番摊'

export function isFantanLottery(name) {
  return name === FANTAN_LOTTERY_NAME
}

export const playTypesFantan = ['番摊']

export const fantanStatsDemo = {
  dan: 126,
  shuang: 110,
  f1: 60,
  f2: 55,
  f3: 66,
  f4: 55
}

export const fantanDrawDemo = {
  balls: [18, 16, 10, 7, 2, 17, 5, 8],
  fan: 4
}

export const longDragonItemsFantan = [
  { text: ' 单:', count: '0期' },
  { text: ' 双:', count: '0期' },
  { text: ' 和:', count: '0期' },
  { text: ' 1番:', count: '0期' },
  { text: ' 2番:', count: '0期' },
  { text: ' 3番:', count: '0期' },
  { text: ' 4番:', count: '0期' },
  { text: ' 角 1-2:', count: '0期' },
  { text: ' 角 2-3:', count: '0期' },
  { text: ' 角 3-4:', count: '0期' },
  { text: ' 角 1-4:', count: '0期' },
]

export const ballNavLabelsFantan = ['1番', '2番', '3番', '4番', '单双']

export const rankPanelsFantan = [
  [['18', '42'], ['16', '38'], ['10', '35'], ['07', '31'], ['02', '28']],
  [['05', '40'], ['08', '36'], ['12', '33'], ['14', '29'], ['19', '25']],
  [['03', '41'], ['11', '37'], ['15', '34'], ['20', '30'], ['22', '26']],
  [['01', '39'], ['04', '35'], ['09', '32'], ['13', '27'], ['21', '24']],
  [['单 126'], ['双 110'], ['和 12'], ['大 88'], ['小 92']]
]

/** 下角「三门 / 通 / 正」表格 */
export const fantanLowerHeader = [
  { label: '三门', odds: '' },
  { label: '通', odds: '' },
  { label: '', odds: '' },
  { label: '', odds: '' },
  { label: '正', odds: '' }
]

export const fantanLowerRows = [
  {
    cells: [
      { text: '4 3 2', sn: 910, sub: 1, odds: '' },
      { text: '23一通', sn: 911, sub: 1, odds: '' },
      { text: '14二通', sn: 912, sub: 1, odds: '' },
      { text: '34二通', sn: 913, sub: 1, odds: '' },
      { text: '正1', sn: 914, sub: 1, odds: '' }
    ]
  },
  {
    cells: [
      { text: '1 4 3', sn: 910, sub: 2, odds: '' },
      { text: '12一通', sn: 911, sub: 2, odds: '' },
      { text: '24一通', sn: 912, sub: 2, odds: '' },
      { text: '13二通', sn: 913, sub: 2, odds: '' },
      { text: '正2', sn: 914, sub: 2, odds: '' }
    ]
  },
  {
    cells: [
      { text: '2 1 4', sn: 910, sub: 3, odds: '' },
      { text: '34一通', sn: 911, sub: 3, odds: '' },
      { text: '23二通', sn: 912, sub: 3, odds: '' },
      { text: '12二通', sn: 913, sub: 3, odds: '' },
      { text: '正3', sn: 914, sub: 3, odds: '' }
    ]
  },
  {
    cells: [
      { text: '3 2 1', sn: 910, sub: 4, odds: '' },
      { text: '14一通', sn: 911, sub: 4, odds: '' },
      { text: '13一通', sn: 912, sub: 4, odds: '' },
      { text: '24二通', sn: 913, sub: 4, odds: '' },
      { text: '正4', sn: 914, sub: 4, odds: '' }
    ]
  }
]

export const fantanChips = [
  { v: 10, color: 'chip--g' },
  { v: 50, color: 'chip--b' },
  { v: 100, color: 'chip--p' },
  { v: 250, color: 'chip--m' },
  { v: 500, color: 'chip--r' },
  { v: 1000, color: 'chip--y' }
]